import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f74141f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Скопировать данные из", -1))
const _hoisted_2 = { class: "card card-body Container-card" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6 ModelField-colFirst" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_7 = { class: "col-6 ModelField-colLast" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Код контейнера", -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-4 ModelField-colFirst" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Длина (мм)", -1))
const _hoisted_12 = { class: "col-4 ModelField-col" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Ширина (мм)", -1))
const _hoisted_14 = { class: "col-4 ModelField-colLast" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Высота (мм)", -1))
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-4 ModelField-colFirst" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Грузоподъемность (кг)", -1))
const _hoisted_19 = { class: "col-4 ModelField-col" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Отступы", -1))
const _hoisted_21 = { class: "col-4 ModelField-colLast" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Количество", -1))
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-6 ModelField-colFirst" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Вес реквизита (кг)", -1))
const _hoisted_26 = { class: "col-6 ModelField-colLast" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Рекомендуемый порог статнагрузки (м³) ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Информация", -1))
const _hoisted_29 = { class: "card card-body Container-card" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title Container-title" }, " Данные для расчета допустимого смещения ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Допускаемое смещение общего ЦТ груза в транспорте ", -1))
const _hoisted_32 = { class: "container-fluid" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-6 ModelField-colFirst" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Вес порожнего транспортного средства (кг) ", -1))
const _hoisted_36 = { class: "col-6 ModelField-colLast" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Высота ЦТ порожнего транспортного средства (мм) ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_CatalogueSelectControl, {
          class: "ModelField-selectControl",
          stylingMode: "outlined",
          id: model.containerId,
          "onUpdate:id": ($event: any) => ((model.containerId) = $event),
          desc: model.containerDescription,
          "onUpdate:desc": ($event: any) => ((model.containerDescription) = $event),
          keyField: "id",
          displayDescField: "name",
          catalogueComponentName: "catalogues/ContainerCatalogue/ContainerCatalogue",
          hasEmptyValue: true,
          validationGroup: validationGroup,
          onChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange()))
        }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_DxTextBox, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Наименование...",
                "show-clear-button": true,
                value: model.name,
                "onUpdate:value": ($event: any) => ((model.name) = $event)
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_DxTextBox, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Код...",
                "show-clear-button": true,
                value: model.code,
                "onUpdate:value": ($event: any) => ((model.code) = $event)
              }, null, 8, ["value", "onUpdate:value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Длина...",
                min: 0,
                value: model.length,
                "onUpdate:value": ($event: any) => ((model.length) = $event)
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Ширина...",
                min: 0,
                value: model.width,
                "onUpdate:value": ($event: any) => ((model.width) = $event)
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Высота...",
                min: 0,
                value: model.height,
                "onUpdate:value": ($event: any) => ((model.height) = $event)
              }, null, 8, ["value", "onUpdate:value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Грузоподъемность...",
                decimalPoints: 2,
                min: 0,
                value: model.loadCapacity,
                "onUpdate:value": ($event: any) => ((model.loadCapacity) = $event)
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_CatalogueSelectControl, {
                class: "ModelField-selectControl",
                stylingMode: "outlined",
                id: model.gapId,
                "onUpdate:id": ($event: any) => ((model.gapId) = $event),
                desc: model.gapDescription,
                "onUpdate:desc": ($event: any) => ((model.gapDescription) = $event),
                displayDescField: "name",
                keyField: "id",
                catalogueComponentName: "catalogues/GapCatalogue/GapCatalogue",
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Количество...",
                min: 0,
                value: model.count,
                "onUpdate:value": ($event: any) => ((model.count) = $event)
              }, null, 8, ["value", "onUpdate:value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Вес реквизита...",
                decimalPoints: 3,
                min: 0,
                value: model.requisiteWeight,
                "onUpdate:value": ($event: any) => ((model.requisiteWeight) = $event)
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Рекомендуемый порог статнагрузки...",
                decimalPoints: 3,
                min: 0,
                max: 100,
                value: model.loadStatThreshold,
                "onUpdate:value": ($event: any) => ((model.loadStatThreshold) = $event)
              }, null, 8, ["value", "onUpdate:value"])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_28,
          _createVNode(_component_DxTextArea, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Информация",
            autoResizeEnabled: true,
            value: model.info,
            "onUpdate:value": ($event: any) => ((model.info) = $event)
          }, null, 8, ["value", "onUpdate:value"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_DxCheckBox, {
            class: "PlanContainer-checkbox",
            value: model.isSelectedForPlanning,
            "onUpdate:value": ($event: any) => ((model.isSelectedForPlanning) = $event),
            text: "Выбран для планирования"
          }, null, 8, ["value", "onUpdate:value"])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", null, [
            _hoisted_31,
            _createVNode(_component_CatalogueSelectControl, {
              class: "ModelField-selectControl",
              stylingMode: "outlined",
              id: model.displacementId,
              "onUpdate:id": ($event: any) => ((model.displacementId) = $event),
              desc: model.displacementDescription,
              "onUpdate:desc": ($event: any) => ((model.displacementDescription) = $event),
              displayDescField: "name",
              keyField: "id",
              catalogueComponentName: "catalogues/DisplacementCatalogue/DisplacementCatalogue",
              hasEmptyValue: false,
              validationGroup: validationGroup
            }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode(_component_DecimalControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Вес порожнего ТС...",
                  decimalPoints: 3,
                  min: 0,
                  value: model.emptyWeight,
                  "onUpdate:value": ($event: any) => ((model.emptyWeight) = $event)
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode(_component_IntegerControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Высота ЦТ порожнего ТС...",
                  min: 0,
                  value: model.emptyHeight,
                  "onUpdate:value": ($event: any) => ((model.emptyHeight) = $event)
                }, null, 8, ["value", "onUpdate:value"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback"]))
}